import { Palette, ToggleButtonGroup } from '@mui/material';

import { Environment } from '@playq/octopus-common';

import { styledCustom } from '/styles/helpers/styledCustom';

export const ToggleButtonGroupStyled = styledCustom(ToggleButtonGroup)<{
  $env: Environment;
}>`
  ${({ theme, $env }) => {
    const envKey = $env.toLowerCase() as keyof Palette['promotion'];
    const envColor = theme.palette.promotion[envKey];
    const neutralText = theme.palette.text.secondary;
    const oppositeEnv = $env === 'Live' ? 'Sandbox' : 'Live';
    const oppositeKey = oppositeEnv.toLowerCase() as keyof Palette['promotion'];
    const oppositeColor = theme.palette.promotion[oppositeKey];

    return `
      display: inline-flex;
      border: 1px solid ${envColor};
      background-color: transparent;
      padding: 0;
      overflow: hidden;

      .MuiToggleButton-root {
        flex: 1;
        border: none;
        border-radius: 0;
        padding: 6px 16px;
        color: ${neutralText};
        background-color: transparent;
        transition: background-color 0.2s ease, color 0.2s ease;

        &:hover {
          background-color: ${oppositeColor}33;
          color: ${oppositeColor};
        }

        &.Mui-selected {
          background-color: ${envColor}33;
          color: ${envColor};

          &:hover {
            background-color: ${envColor}4D;
          }
        }

        &.Mui-disabled {
          &.Mui-selected {
            display: inline-flex;
          }

          &:not(.Mui-selected) {
            display: none;
          }
        }

        &:first-of-type {
          border-top-left-radius: 3px;
          border-bottom-left-radius: 3px;

          &.Mui-selected {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
          }
        }

        &:last-of-type {
          border-top-right-radius: 3px;
          border-bottom-right-radius: 3px;

          &.Mui-selected {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
          }
        }

        &:not(:first-of-type) {
          border-left: 1px solid ${envColor}33;
        }
      }
    `;
  }}
`;
